import { Box, Button, Card, Divider, Grid, IconButton, TableBody, TableCell, TableRow, Typography } from "@mui/material";
import { IHeaderGrid } from "../../interfaces/grid/IHeaderGrid";
import GridContent from "../../components/grid";
import GridHeader from "../../components/grid/header";
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from "react-router-dom";
import { getBaseURLWithAuth } from "../../common/utils/session";
import { useEffect, useState } from "react";
import { ICryptoCurrency } from "../../interfaces/crypto-currency/ICryptoCurrency";
import { useNotification } from "../../components/notification/useNotification";
import extractErrorMessage from "../../common/utils/errorMessages";
import Loader from "../../components/loader";
import { formatPriceToDolar } from "../../common/utils/number";
import { defaultControllerPagination, IPagination } from "../../interfaces/pagination/IPagination";
import Pagination from "../../components/grid/pagination";
import useLazyLoading from "../../common/hooks/loader";
import { tryDeleteCryptoCurrencyById, tryGetCryptoCurrencyByUserIdList } from "../../services/crypto-currency/cripto-currency.service";

const headerColumnList: IHeaderGrid[] = [
    {
        align: 'left',
        name: 'Nome',
        padding: 'normal'
    },
    {
        align: 'left',
        name: 'Preço',
        padding: 'normal'
    },
    {
        align: 'right',
        name: 'Remover',
        padding: 'normal'
    },
];

export default function Currency() {

    const navigate = useNavigate();
    const { displayNotification } = useNotification();
    const [loading, setLoading] = useState(false);
    const showLoading = useLazyLoading(loading);
    const [cryptoCurrencyList, setCryptoCurrencyList] = useState<ICryptoCurrency[]>();
    const [rowCount, setRowCount] = useState<number>(0);
    const [pagination, setPagination] = useState<IPagination>(defaultControllerPagination);

    useEffect(() => {

        async function getCryptoCurrencyList() {
            setLoading(true);
            try {
                var response = (await tryGetCryptoCurrencyByUserIdList(pagination)).data;

                if (response) {
                    setCryptoCurrencyList(response.results);
                    setRowCount(response.rowCount);
                }
            }
            catch (error) {
                displayNotification({ type: 'error', message: extractErrorMessage(error) })
            }
            finally {
                setLoading(false);
            }
        }
        getCryptoCurrencyList();

    }, [pagination]);


    const handleRemoveCryptoCurrency = async (cryptoCurrencyId: string) => {
        setLoading(true);

        try {
            var response = await tryDeleteCryptoCurrencyById(cryptoCurrencyId);

            if (response?.status === 202) {
                displayNotification({ type:'success', message: 'Crypto moeda apagada com sucesso.' });

                var newCryptoCurrencyList = cryptoCurrencyList?.filter(x => x.id != cryptoCurrencyId);
        
                if (newCryptoCurrencyList) {
                    setCryptoCurrencyList(newCryptoCurrencyList);
                }
            }
        } catch (error) {
            displayNotification({type: 'error', message: extractErrorMessage(error)});
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            {showLoading === true ? <Loader /> : null}
            <Box mt={3} mb={1}>
                <Grid container justifyContent="space-between" alignItems="flex-start">
                    <Grid>
                        <Typography variant="h4" fontWeight={700} sx={{ color: 'primary.main', letterSpacing: 1 }}>
                            Gestão de Moedas
                        </Typography>
                        <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
                            Consulta e gestão das criptomoedas do teu portfolio
                        </Typography>
                    </Grid>
                    <Grid>
                        <Button variant="contained" color="primary" onClick={() => navigate(getBaseURLWithAuth() + 'cryptocurrency/create')}>
                            Criar Moeda
                        </Button>
                    </Grid>
                </Grid>
                <Divider sx={{ mt: 2, borderColor: 'rgba(255,215,0,0.15)' }} />
            </Box>
            <Card sx={{ mt: 2, border: '1px solid rgba(255,215,0,0.15)' }}>
                <Box>
                    <GridContent>
                        <GridHeader headerProps={headerColumnList} />
                        <TableBody>
                            {cryptoCurrencyList && cryptoCurrencyList.map((currency, index) => (
                                <TableRow
                                    key={currency.id}
                                    sx={{
                                        backgroundColor: index % 2 !== 0 ? 'rgba(255,255,255,0.02)' : 'transparent',
                                        '&:hover': { backgroundColor: 'rgba(255,215,0,0.05)' },
                                        transition: 'background-color 0.15s ease',
                                    }}
                                >
                                    <TableCell align="left">
                                        <Grid container alignItems="center" spacing={0.5}>
                                            <Grid>
                                                <img src={currency.imageUrl} width="20" height="20" />
                                            </Grid>
                                            <Grid>
                                                <strong>{currency.name}</strong>
                                            </Grid>
                                        </Grid>
                                    </TableCell>
                                    <TableCell align="left">
                                        <Grid>
                                            {formatPriceToDolar(currency.price)}
                                        </Grid>
                                    </TableCell>
                                    <TableCell align="right">
                                        <IconButton color="error" onClick={() => handleRemoveCryptoCurrency(currency.id)}>
                                            <DeleteIcon />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </GridContent>
                    <Pagination rowCount={rowCount} pagination={pagination} setController={setPagination}/>
                </Box>
            </Card>
        </>
    )
}